'use client'
import { GET_POPULAR_TEAMS } from '@/graphql/globalwidget/rankings.query'
import CustomLink from '@/shared/components/customLink'
import MyImage from '@/shared/components/myImage'
import { BLUR_DATA_URL_BASE64, S3_PREFIX } from '@/shared/constants'
import { allRoutes } from '@/shared/constants/allRoutes'
import { getSlugUrl } from '@/shared/utils'
import { useQuery } from '@apollo/client'

function TrendingTeams() {
  const { data } = useQuery(GET_POPULAR_TEAMS)
  const teams = data?.listPopularTeams

  if (teams?.length === 0) return null

  const limit = 5
  return (
    <section className="w-full">
      <div className="flex justify-between items-center my-3">
        <h3 className="font-bold text-lg mb-0 text-textOffWhite flex items-center justify-center md:justify-start">
          <span>Trending Teams</span>
        </h3>
        <CustomLink
          href={allRoutes.teams as string}
          className="font-medium text-sm text-primary-500 hover:text-primary-500 transition-colors"
        >
          View All
        </CustomLink>
      </div>
      <div
        className={
          'py-3 px-4 flex flex-col font-semibold border border-tabBorder rounded-xl bg-cardBg'
        }
      >
        {teams?.slice(0, limit).map((data: any, index: number) => {
          return (
            <CustomLink
              key={data?._id}
              href={getSlugUrl(`/${data?.oSeo?.sSlug}`)}
              className={`flex items-center first:pt-0 last:pb-0 py-3 ${index !== limit - 1 ? 'border-b border-tabBorder' : ''}`}
            >
              <>
                <div className={`overflow-hidden rounded-full`}>
                  <MyImage
                    src={data?.oImg?.sUrl ? `${S3_PREFIX}${data?.oImg?.sUrl}` : ''}
                    alt={data?.sTitle}
                    loadOnScroll
                    placeholderType="team"
                    className="aspect-square rounded-full"
                    blurDataURL={BLUR_DATA_URL_BASE64}
                    placeholder="blur"
                    width={44}
                    height={44}
                  />
                </div>
                <div className="mt-1 mx-3 font-normal">
                  <h5 className="w-full text-sm font-medium hover:text-primary-500 text-textOffWhite">
                    {data?.sTitle}
                  </h5>
                </div>
              </>
            </CustomLink>
          )
        })}
      </div>
    </section>
  )
}

export default TrendingTeams
